<template>
  <div class="px-10 py-3">
    <v-row>
      <v-col cols="12" md="auto" style="width: 330px">
        <div class="mr-md-6 mr-0">
          <!-- Photo -->
          <div v-if="showPhoto || type === 'parent'">
            <div class="app-section-title">{{ $t('content.user_upload_title') }}</div>
            <form-group :name="$t('form.logo')" :validator="$v.form.image" no-gutter class="mb-8">
              <template slot-scope="{ attrs }">
                <image-box
                  v-model="form.image"
                  v-bind="attrs"
                  :with-upload="editable"
                  :upload-btn-text="$t(initialData ? 'change_photo' : 'upload')"
                  :image-preview="imageUrl"
                  @change="$v.form.image.$touch()"
                  class="mt-4"
                />
              </template>
            </form-group>
          </div>
          <v-btn color="primary" block class="btn-primary-custom mb-8" v-if="!showPhoto && type !== 'parent' && editable" @click="togglePhoto">
            {{ $t('content.add_photo') }}
          </v-btn>
          <form-group :name="$t('form.status')" :validator="$v.form.status">
            <template slot-scope="{ attrs }">
              <v-select :items="itemStatus" :label="$t('form.status')" :disabled="!editable" v-model="form.status" v-bind="attrs">
                <template #item="{item}">{{ $t(item.text) }}</template>
                <template #selection="{item}">{{ $t(item.text) }}</template>
              </v-select>
            </template>
          </form-group>
        </div>
      </v-col>
      <v-col>
        <!-- Personal -->
        <div class="app-section-title d-flex align-center justify-space-between mb-4">
          {{ $t('content.personal_information') }}
          <v-btn
            v-if="!parentBtnHide"
            v-show="forceHideBtn"
            color="primary"
            class="btn-primary-custom"
            :loading="parentBtnLoading"
            @click="parentEdit"
          >
            {{ $t(parentIsFound ? 'edit' : 'add') }}
          </v-btn>
        </div>
        <form-group v-if="isStudent" :name="$t('form.student_id')">
          <template>
            <v-text-field
              v-model="form.identityNumber"
              :label="$t('form.student_id')"
              disabled
              @input="$v.form.identityNumber.$touch()"
              @blur="$v.form.identityNumber.$touch()"
            >
              <template #label>
                {{ $t('form.student_id') }}
              </template>
            </v-text-field>
          </template>
        </form-group>
        <form-group v-if="!isStudent" :name="$t('form.email')" :validator="$v.form.email">
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="form.email"
              v-bind="attrs"
              :label="$t('form.email')"
              :disabled="!editable"
              :loading="parentSearchLoading"
              @input="$v.form.email.$touch()"
              @blur="$v.form.email.$touch()"
              @keyup="getParentByEmail"
            >
              <template #append>
                <v-icon v-if="type == 'parent' && !parentBtnHide">{{ parentIsFound ? 'mdi-check-bold' : 'mdi-alert' }}</v-icon>
              </template>
              <template #label>
                {{ $t('form.email') }}
                <span class="error--text">*</span>
              </template>
            </v-text-field>
          </template>
        </form-group>
        <form-group :name="$t('form.first_name')" :validator="$v.form.firstName">
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="form.firstName"
              v-bind="attrs"
              :label="$t('form.first_name')"
              :disabled="!editable"
              @input="$v.form.firstName.$touch()"
              @blur="$v.form.firstName.$touch()"
            >
              <template #label>
                {{ $t('form.first_name') }}
                <span class="error--text">*</span>
              </template>
            </v-text-field>
          </template>
        </form-group>
        <form-group :name="$t('form.last_name')" :validator="$v.form.lastName">
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="form.lastName"
              v-bind="attrs"
              :label="$t('form.last_name')"
              :disabled="!editable"
              @input="$v.form.lastName.$touch()"
              @blur="$v.form.lastName.$touch()"
            />
          </template>
        </form-group>
        <form-group :name="$t('form.gender')" :validator="$v.form.gender">
          <template slot-scope="{ attrs }">
            <v-select :items="itemGender" :disabled="!editable" v-model="form.gender" v-bind="attrs">
              <template #label>
                {{ $t('form.gender') }}
                <span class="error--text">*</span>
              </template>
              <template #item="{item}">{{ $t(item.text) }}</template>
              <template #selection="{item}">{{ $t(item.text) }}</template>
            </v-select>
          </template>
        </form-group>

        <form-group :name="$t('form.place_of_birth')" :validator="$v.form.placeOfBirth">
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="form.placeOfBirth"
              v-bind="attrs"
              :disabled="!editable"
              @input="$v.form.placeOfBirth.$touch()"
              @blur="$v.form.placeOfBirth.$touch()"
            >
              <template #label>
                {{ $t('form.place_of_birth') }}
                <span class="error--text">*</span>
              </template>
            </v-text-field>
          </template>
        </form-group>
        <form-group v-slot="{ attrs, on }" :name="$t('form.date_of_birth')" :validator="$v.form.dateOfBirth">
          <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
              <v-text-field
                v-model="form.dateOfBirth"
                :disabled="!editable"
                readonly
                v-bind="{ ...attrs, ...menuAttrs }"
                v-on="{ ...on, ...menuOn }"
                @blur="$v.form.dateOfBirth.$touch()"
              >
                <template #label>
                  {{ $t('form.date_of_birth') }}
                  <span class="error--text">*</span>
                </template>
                <template #append> <svg-icon icon="calendar" class="primary--text mr-3" /> </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="form.dateOfBirth" :active-picker.sync="activePicker" :max="maxDate" :locale="$i18n.locale">
              <template #label>
                {{ $t('form.date_of_birth') }}
                <span class="error--text">*</span>
              </template>
            </v-date-picker>
          </v-menu>
        </form-group>
        <form-group v-if="isStudent" :name="$t('form.email')" :validator="$v.form.email">
          <template slot-scope="{ attrs }">
            <v-text-field v-model="form.email" v-bind="attrs" disabled @input="$v.form.email.$touch()" @blur="$v.form.email.$touch()">
              <template #label>
                {{ $t('form.email') }}
                <span class="error--text">*</span>
              </template>
            </v-text-field>
          </template>
        </form-group>
        <form-group :name="$t('form.phone_number')" :validator="$v.form.phoneNumber">
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="form.phoneNumber"
              v-bind="attrs"
              v-phone
              :label="$t('form.phone_number')"
              :disabled="!editable || type != 'parent'"
              @input="$v.form.phoneNumber.$touch()"
              @blur="$v.form.phoneNumber.$touch()"
            >
              <template #label>
                {{ $t('form.phone_number') }}
                <span class="error--text">*</span>
              </template>
            </v-text-field>
          </template>
        </form-group>

        <!-- Address -->
        <div class="app-section-title">{{ $t('content.address_information') }}</div>
        <form-group :name="$t('form.address')" :validator="$v.form.address">
          <template slot-scope="{ attrs }">
            <v-textarea
              v-model="form.address"
              v-bind="attrs"
              :disabled="!editable || type != 'parent'"
              @input="$v.form.address.$touch()"
              @blur="$v.form.address.$touch()"
            >
              <template #label>
                {{ $t('form.address') }}
                <span class="error--text">*</span>
              </template>
            </v-textarea>
          </template>
        </form-group>
        <form-group :name="$t('form.province')" :validator="$v.form.provinceId">
          <template slot-scope="{ attrs }">
            <v-autocomplete
              :items="provinces"
              :disabled="!editable || type != 'parent'"
              item-value="provinceId"
              item-text="name"
              v-model="form.provinceId"
              v-bind="attrs"
              @change="getCities"
            >
              <template #label>
                {{ $t('province') }}
                <span class="error--text">*</span>
              </template>
            </v-autocomplete>
          </template>
        </form-group>
        <form-group :name="$t('form.city')" :validator="$v.form.cityId">
          <template slot-scope="{ attrs }">
            <v-autocomplete
              :items="cities"
              :disabled="!editable || type != 'parent'"
              item-value="cityId"
              item-text="name"
              v-model="form.cityId"
              v-bind="attrs"
            >
              <template #label>
                {{ $t('city') }}
                <span class="error--text">*</span>
              </template>
            </v-autocomplete>
          </template>
        </form-group>
        <form-group :name="$t('form.postal_code')" :validator="$v.form.postalCode" no-gutter>
          <template slot-scope="{ attrs }">
            <v-text-field
              minlength="5"
              maxlength="5"
              v-model="form.postalCode"
              v-bind="attrs"
              v-number
              :label="$t('form.postal_code')"
              :disabled="!editable || type != 'parent'"
              @input="$v.form.postalCode.$touch()"
              @blur="$v.form.postalCode.$touch()"
            />
          </template>
        </form-group>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { omit, debounce } from 'lodash';
import { mapGetters } from 'vuex';
import { required, email, numeric, maxLength, requiredIf } from 'vuelidate/lib/validators';
import phoneNumber from '@/validators/phoneNumber';
import { fileSize, alphaSpace } from '@/validators';
import ImageBox from '@/components/ImageBox';
export default {
  name: 'StudentParentForm',
  props: {
    type: {
      type: String,
      default: 'student'
    },
    editable: {
      type: Boolean,
      default: true
    },
    initialData: {
      type: Object,
      default: null
    },
    editableParentEmail: {
      type: Boolean,
      default: true
    },
    forceHideBtn: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ImageBox
  },
  validations: function() {
    return {
      form: {
        image: { fileSize: fileSize(1) },
        firstName: { required, alphaSpace, maxLength: maxLength(30) },
        lastName: { alphaSpace, maxLength: maxLength(30) },
        gender: { required },
        placeOfBirth: { required, alpha: alphaSpace },
        dateOfBirth: { required },
        email: {
          required,
          email,
          async notSameEmail(value) {
            if (this.type != 'parentCreateEdit') {
              let comparer = this.$store.getters[`Student/${this.type != 'student' ? 'studentEmail' : 'parentEmail'}`];
              return comparer != value;
            }
            return true;
          },
          [this.validationName](value) {
            // If Parent & Editable False disable validation
            if (!value || (!this.editable && this.type == 'parent')) return true;
            return new Promise(resolve => {
              this.axios
                .get('api/user/validate-email', {
                  params: {
                    email: value,
                    roleId: this.type == 'student' ? 5 : 3,
                    userId: this.initialData?.userId || this.$route.params?.id || null
                  }
                })
                .then(() => resolve(true))
                .catch(err => {
                  const code = err?.response?.data?.errorMessages;
                  const errorCode = ['isRegistered', 'isRegisteredInactive', 'isRegisteredInAnotherRole'];
                  this.validationName = errorCode?.[code - 1];
                  resolve(false);
                });
            });
          },
          ...(this.parentError ? { isRegisteredInAnotherRole: () => false } : null)
        },
        phoneNumber: {
          required: requiredIf(function() {
            return this.type !== 'student';
          }),
          phone: phoneNumber,
          maxLength: maxLength(15)
        },
        address: { required, maxAddressLength: maxLength(255) },
        provinceId: { required },
        cityId: { required },
        postalCode: { numeric, maxLength: maxLength(5) },
        status: { required }
      }
    };
  },
  computed: {
    ...mapGetters({
      provinces: 'Reference/itemProvinces',
      itemStatus: 'Reference/itemStatus',
      itemGender: 'Reference/itemGender'
    }),
    cities: {
      get() {
        return this.$store.getters['Reference/itemCities'](this.isStudent ? 0 : 1);
      }
    },
    isStudent() {
      return this.type === 'student';
    },
    isCreatePage() {
      return this.$route.name === 'CreateParent';
    },
    maxDate() {
      const isStudent = this.type === 'student';
      const d = new Date();
      d.setFullYear(d.getFullYear() - (isStudent ? 5 : 17));
      return d.toISOString().split('T')[0];
    }
  },
  data: function() {
    return {
      menu: false,
      imageUrl: null,
      parentBtnHide: true,
      parentBtnLoading: false,
      parentSearchLoading: false,
      parentIsFound: false,
      parentId: null,
      parentError: false,
      validationName: 'dynamic',
      showPhoto: false,
      activePicker: null,
      form: {
        userId: null,
        firstName: '',
        lastName: '',
        gender: '',
        placeOfBirth: '',
        dateOfBirth: '',
        email: 'aa',
        phoneNumber: '',
        address: '',
        provinceId: '',
        cityId: '',
        postalCode: '',
        status: true,
        image: null,
        used: '',
        ...(this.type === 'student' ? { identityNumber: '' } : null)
      }
    };
  },
  watch: {
    initialData: {
      deep: true,
      immediate: true,
      handler: function(items) {
        if (this.isCreatePage) {
          items = null;
          this.setDefaultFormData();
        }
        if (items) {
          if (this.type === 'parent') {
            this.parentIsFound = true;
            this.parentId = items.parentId;
            this.parentBtnHide = false;
          }

          Object.keys(this.form).forEach(field => {
            this.form[field] = items?.[field];
          });

          if (items.imageUrl) {
            this.imageUrl = items.imageUrl;
            this.showPhoto = true;
          }

          this.getCities();
        }
      }
    },
    'form.firstName': {
      deep: true,
      immediate: true,
      handler: function(student_name) {
        if (this.isStudent && this.$route.name === 'AddStudent') {
          const name = student_name?.split(' ')[0]?.toLowerCase();
          this.form.email = this.emailTemplateBuilder(name);
        }
      }
    },
    'form.email': function(newVal) {
      if (this.type == 'student') {
        this.$store.commit('Student/SET_STUDENT_EMAIL', newVal);
      } else if (this.type === 'parent') {
        this.$store.commit('Student/SET_PARENT_EMAIL', newVal);
      }
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'));
    }
  },
  methods: {
    emailTemplateBuilder(name) {
      const year = new Date().getFullYear().toString();
      const randomTwoDigit = Math.floor(Math.random() * 90) + 10;
      if (!name) return '';
      return `${name}${year.slice(-2)}${randomTwoDigit}@dinocode.id`;
    },
    setDefaultFormData() {
      this.form = {
        userId: null,
        firstName: '',
        lastName: '',
        gender: '',
        placeOfBirth: '',
        dateOfBirth: '',
        email: '',
        phoneNumber: '',
        address: '',
        provinceId: '',
        cityId: '',
        postalCode: '',
        status: true,
        image: null,
        used: '',
        ...(this.type === 'student' ? { identityNumber: '' } : null)
      };
    },
    getProvinces() {
      this.$store.dispatch('Reference/fetchProvinces');
    },
    getCities() {
      if (!this.form.provinceId) return;
      this.$store.dispatch('Reference/fetchCities', { index: this.isStudent ? 0 : 1, provinceId: this.form.provinceId });
    },
    getData() {
      return {
        ...this.form,
        lastName: this.form.lastName ?? ''
      };
    },
    getParentId() {
      return this.parentId;
    },
    getParentByEmail: debounce(function(e) {
      this.parentBtnLoading = true;

      // Disable Arrow Up/Bottom
      if ([40, 38].includes(e.keyCode ? e.keyCode : e.which)) return;

      // Disable if editable
      if (this.editable) return;

      // Hit api if format email right
      if (!this.$v.form.email.$invalid) {
        this.parentSearchLoading = true;
        this.$store
          .dispatch('Student/fetchParentByEmail', this.form.email)
          .then(res => {
            Object.keys(this.form).forEach(field => (this.form[field] = res[field]));
            if (res.imageUrl) {
              this.imageUrl = res.imageUrl;
              this.showPhoto = true;
            }
            this.parentIsFound = true;
            this.parentId = res.parentId;
            this.parentError = false;
            this.parentBtnHide = false;
          })
          .catch(err => {
            this.clearForm();
            const errorAnotherRole = err.response.data.errorMessages == 1;
            this.parentIsFound = false;
            this.imageUrl = null;
            this.parentError = errorAnotherRole;
            this.parentBtnHide = errorAnotherRole;
          })
          .finally(() => {
            this.getCities();
            this.parentSearchLoading = false;
            this.parentBtnLoading = false;
          });
      } else {
        this.clearForm();
        this.parentBtnLoading = false;
        this.parentError = false;
        this.parentBtnHide = true;
        this.imageUrl = null;
      }
    }, 200),
    parentEdit() {
      this.$root.$emit('parentEdit', { ...this.form, imageUrl: this.imageUrl });
    },
    clearForm() {
      Object.keys(omit(this.form, 'email')).forEach(field => (this.form[field] = ''));
      this.parentIsFound = false;
      this.parentId = null;
    },
    togglePhoto() {
      this.showPhoto = !this.showPhoto;
    }
  },
  created() {
    this.$store.commit('Reference/RESET_CITIES', this.isStudent ? 0 : 1);
    this.getProvinces();
  }
};
</script>
